import loadable from '@loadable/component';
import { type FunctionComponent } from 'react';
import { type ProjectFieldsFragment } from '../../__generated__/graphql-client-types';
import { type ProjectInputWithName } from '../../types/project.types';

const LoadableSaveToProjectDrawer = loadable(
	() => import(/* webpackChunkName: "save-to-project-drawer" */ './save-to-project-drawer/save-to-project-drawer.component'),
	{
		resolveComponent: ({ SaveToProjectDrawer }) => SaveToProjectDrawer
	}
);

export const LoadableSaveToProject: FunctionComponent<{
	headerText: string;
	buttonText: string;
	secondaryButtonText?: string;
	currentProjectId?: number;
	isActionLoading: boolean;
	initialQuantity?: number;
	showQuantityInput?: boolean;
	showProjectsOnly?: boolean;
	handleAction?: (projectInput: ProjectInputWithName[]) => void;
	handleAttachOrderToProject?: (project?: ProjectFieldsFragment) => void;
	handleSecondaryAction?: () => void;
	onClose: () => void;
	trackNewProjectClick?: () => void;
}> = ({
	headerText,
	buttonText,
	secondaryButtonText,
	currentProjectId,
	isActionLoading,
	initialQuantity,
	showQuantityInput = false,
	showProjectsOnly,
	handleAction,
	handleSecondaryAction,
	handleAttachOrderToProject,
	onClose,
	trackNewProjectClick
}) => {
	return (
		<LoadableSaveToProjectDrawer
			headerText={headerText}
			buttonText={buttonText}
			secondaryButtonText={secondaryButtonText}
			isActionLoading={isActionLoading}
			currentProjectId={currentProjectId}
			initialQuantity={initialQuantity}
			showQuantityInput={showQuantityInput}
			showProjectsOnly={showProjectsOnly}
			handleSaveToProject={(projectInput) => handleAction?.(projectInput)}
			handleAttachOrderToProject={handleAttachOrderToProject}
			handleSecondaryAction={handleSecondaryAction}
			closeDrawer={onClose}
			trackNewProjectClick={trackNewProjectClick}
		/>
	);
};
